// extracted by mini-css-extract-plugin
export default {"ThemeSwitch":"ThemeSwitch_ThemeSwitch__qImST"};